module.exports = __webpack_public_path__ + "img/logo.83775378.png";